import React from 'react';

interface DaypartingPopupProps {
  recordId: string; // The record ID passed to the component
  handleClose: () => void; // Function to close the popup
  onUpdate: (updatedRecord: any) => void; // Function to handle updates
}

const DaypartingPopup: React.FC<DaypartingPopupProps> = ({ recordId, handleClose, onUpdate }) => {
  const [isEnabled, setIsEnabled] = React.useState<boolean>(false);

  const handleOptionChange = (enabled: boolean) => {
    setIsEnabled(enabled);
  };

  const handleSave = () => {
    const updatedRecord = {
      recordId,
      daypartingEnabled: isEnabled,
    };
    onUpdate(updatedRecord);
    handleClose();
  };

  return (
    <div className="popup-container">
      <div className="popup-header">
        <h4>Campaign: Dayparting</h4>
      </div>
      <div className="popup-content">
        <div className="dayparting-option"  style={{height:'50px'}}>
          <label>
            <input
              type="radio"
              name="dayparting"
              value="disable"
              checked={!isEnabled}
              onChange={() => handleOptionChange(false)}
            />
            <strong style={{fontSize:'14px', marginLeft:'3px'}}>Disable</strong>
            <p style={{marginLeft:'20px', marginTop:'-2px'}}>Choose this option if you want your ad to show continuously throughout the day, on a daily basis.</p>
          </label>
        </div>
        <hr style={{ color: 'lightgray', backgroundColor: 'lightgray', height: '1px', border: 'none' }} />
        <div className="dayparting-option"  style={{height:'50px'}}>
          <label>
            <input
              type="radio"
              name="dayparting"
              value="enable"
              checked={isEnabled}
              onChange={() => handleOptionChange(true)}
            />
            <strong style={{fontSize:'14px', marginLeft:'3px'}}>Enable</strong>
            <p style={{marginLeft:'20px', marginTop:'-2px'}}>Choose this option to select specific days and hours in which your ad will be active.</p>
          </label>
        </div>
        <hr style={{ color: 'lightgray', backgroundColor: 'lightgray', height: '1px', border: 'none' }} />

      </div>
      <div className="popup-actions" style={{textAlign:'center'}}>
        {/* <button onClick={handleClose} className="btn-cancel">
          Cancel
        </button> */}
        <button style={{padding:'3px 40px', backgroundColor:'#1173B7', marginTop:'10px', color:"white", fontSize:'11px', borderColor:'transparent'}} onClick={handleSave} className="btn-save">
          Update Day Parting
        </button>
      </div>
    </div>
  );
};

export default DaypartingPopup;